import React from "react";
import { Box, Grid, HStack, Stack, Text } from "@chakra-ui/react";
import { DashboardTextarea } from "components/utils/FormControls";
import { FaHouseFire, FaToolbox } from "react-icons/fa6";
import { FaCarCrash } from "react-icons/fa";
import { DataCard } from "components/utils/DataCard";
import { FormDialog } from "components/utils/FormDialog";
import { toNullIfEmpty } from "utils/formatters";
import { useDialogForm } from "utils/useDialogForm";

export const PosteriorUsoCuidadosCard = ({ actividad, actividadId, patch }) => {
  const dialog = useDialogForm({ usoClub: "", usoVan: "" });
  const showClub = !!actividad?.club;
  const showVan = !!actividad?.van;
  const hasAnyUso = showClub || showVan;

  const saving = patch.isPending;
  const patchError = patch.isError ? String(patch.error?.message || patch.error) : null;

  const usoClubTxt = actividad?.usoClub?.trim() || "—";
  const usoVanTxt = actividad?.usoVan?.trim() || "—";

  function openDialog() {
    dialog.openWith({ usoClub: actividad?.usoClub ?? "", usoVan: actividad?.usoVan ?? "" });
  }

  async function save() {
    const payload = {};
    if (showClub) payload.usoClub = toNullIfEmpty(dialog.form.usoClub);
    if (showVan) payload.usoVan = toNullIfEmpty(dialog.form.usoVan);

    await patch.mutateAsync({
      actividadId,
      patch: payload,
    });
    dialog.close();
  }

  if (!hasAnyUso) return null;

  return (
    <>
      <DataCard title="Uso y Cuidados" variant="red" headerIcon={<FaToolbox size="24px" />} onEdit={openDialog} editAriaLabel="Editar uso y cuidados">
        <Grid templateColumns={showClub && showVan ? "repeat(2, 1fr)" : "1fr"} gap="4" alignItems="start">
          {showClub ? (
            <HStack gap="2.5" align="start">
              <Box color="dashboard.fg.muted" mt="0.5" flexShrink={0}><FaHouseFire size="16px" /></Box>
              <Stack gap="0">
                <Text fontSize="xs" color="dashboard.fg.muted" textTransform="uppercase" fontWeight="700" letterSpacing="0.06em">Club</Text>
                <Text fontSize="sm" color="dashboard.fg.muted">{usoClubTxt}</Text>
              </Stack>
            </HStack>
          ) : null}

          {showVan ? (
            <HStack gap="2.5" align="start">
              <Box color="dashboard.fg.muted" mt="0.5" flexShrink={0}><FaCarCrash size="16px" /></Box>
              <Stack gap="0">
                <Text fontSize="xs" color="dashboard.fg.muted" textTransform="uppercase" fontWeight="700" letterSpacing="0.06em">Van</Text>
                <Text fontSize="sm" color="dashboard.fg.muted">{usoVanTxt}</Text>
              </Stack>
            </HStack>
          ) : null}
        </Grid>
      </DataCard>

      <FormDialog open={dialog.open} onOpenChange={dialog.onOpenChange} title="Editar Uso y Cuidados" errorText={patchError} saving={saving} onCancel={dialog.close} onSave={save}>
        {showClub ? (
          <Box>
            <Text fontSize="sm" fontWeight="600" color="dashboard.fg.default" mb="1">Club</Text>
            <DashboardTextarea value={dialog.form.usoClub} onChange={(e) => dialog.setField("usoClub", e.target.value)} rows={4} placeholder="Describe el estado/uso del club…" />
            <Text color="dashboard.fg.muted" fontSize="sm" mt="1">Deja vacío para quitar el texto.</Text>
          </Box>
        ) : null}

        {showVan ? (
          <Box>
            <Text fontSize="sm" fontWeight="600" color="dashboard.fg.default" mb="1">Van</Text>
            <DashboardTextarea value={dialog.form.usoVan} onChange={(e) => dialog.setField("usoVan", e.target.value)} rows={4} placeholder="Describe el estado/uso de la van…" />
            <Text color="dashboard.fg.muted" fontSize="sm" mt="1">Deja vacío para quitar el texto.</Text>
          </Box>
        ) : null}
      </FormDialog>
    </>
  );
};
